import CryptoJS from 'crypto-js'

export function encryptParams (param) {
  try {
    let encryptedText = CryptoJS.AES.encrypt(param.toString(), process.env.RESPONSE_SIGNER).toString()
    return encryptedText
  } catch (error) {
    console.error(error)
    return param
  }
}

export function decryptParams (encryptedText) {
  try {
    let bytes = CryptoJS.AES.decrypt(encryptedText, process.env.RESPONSE_SIGNER)
    let originalText = bytes.toString(CryptoJS.enc.Utf8)
    return originalText
  } catch (error) {
    console.error(error)
    return encryptedText
  }
}



// WEBPACK FOOTER //
// ./src/utils/cryptojs_utils.js